import React from 'react'
import { Button, Collection, Divider, Flex, Icon, Menu, MenuButton, MenuItem, Text, View } from '@aws-amplify/ui-react'
import { Grid, TextField } from '@mui/material'
import ReactMarkdown from 'react-markdown';
import { SkewLoader } from 'react-spinners'
import invokegimageagent from '../lambda/invokegimageagent'
import getAuthusercreds from '../aws_utils/getAuthusercreds';
import Modal from 'react-modal'
import { motion } from 'framer-motion'
import ModalImageAgent from '../modals/ModalImageAgent';
import { deleteProjectChat, getProjectChats } from '../apigateway/mongocalls';
import { DisplayImage } from './DisplayImageImageAgent';
import { useAuthStore } from 'store';


export default function QueryboxImageAgent(props) {

   const [onHoverChat, setonHoverChat] = React.useState(false)
    const [deleteChatModel, setdeleteChatModel] = React.useState(false)
      const [chatIdToDelete, setchatIdToDelete] = React.useState('')
    const [hoverChatId, sethoverChatId] = React.useState('');   
    const closeDeleteChatModal = () => {
            setdeleteChatModel(false);
          };
    const [query, setQuery] = React.useState("")
    const [isloading, setisloading] = React.useState(false)
    const currentproject = props.projectname
    const [projectconversation, setprojectconversation] = React.useState([])
    const { authToken, refreshToken} = useAuthStore();


    const UserChat = async () => {
       if(authToken){
        const userschat = await getProjectChats(currentproject, authToken)

         // Refresh Token
              if(userschat === 'refresh token'){
                      // console.log('refresh token from dummy agent...')
                        const refreshResp = await refreshToken();
                        if(refreshResp){
                        // console.log('refreshed auth token?', refreshResp);
                        const userschat = await getProjectChats(currentproject, refreshResp);
                        const imgconversations = userschat.filter(img => img.image === true)
                         setprojectconversation(imgconversations.reverse())
                          setnewquery(false)
                          setisloading(false)
                        return
                        }
                      return
                }

        const imgconversations = userschat.filter(img => img.image === true)
        setprojectconversation(imgconversations.reverse())
        setnewquery(false)
        setisloading(false)
              }
      }

    const [cogid, setcogid] = React.useState('')
    React.useEffect(() => {
      const GetCogId = async () => {
      try {
          const id = await getAuthusercreds()
          const identityId = id.identityId
        //   console.log("id", id.identityId)
          setcogid(identityId)
      } catch (error) {
          console.log(error)
      }
      }
      GetCogId()
    }, [])
    
    
    React.useEffect(() => {
      // console.log("Current Project", currentproject)
      if(currentproject === "" || currentproject === null || currentproject === undefined){
        return
      }
      UserChat()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentproject])

    const [newquery, setnewquery] = React.useState(false)
    React.useEffect(() => {
      // console.log("New query triggered", newquery)
      const refreshquerybox = async () => {
        if(newquery){
        UserChat()
        }
        // setnewquery(false)
        // setisloading(false)
      }
      refreshquerybox()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newquery])

   
    

    const QueryImageAgent = async () => {
    
      if(currentproject === "" || currentproject === null || currentproject === undefined){
        setisloading(false);
        window.scrollTo(0,0);
        alert("Select or Create Project!")
        // console.log("Select Project");
        return
        }
        if(query === ""){
            setnewquery(false);
            setisloading(false)
            alert("Enter query!")
            // console.log("Query")
            return
        }

        await invokegimageagent(query, currentproject, cogid)
        setnewquery(true)
        // setisloading(false)
        setQuery(" ")
        window.scrollTo(0,document.body.scrollHeight);
        
    }

  

    const [showQueryBox, setShowQueryBox] = React.useState(false)
    const closeQueryBox = async () => {
        setShowQueryBox(false)
        UserChat()
    }






  return (
     <View
    // position="relative"
    // paddingTop="5px"
    // paddingBottom="15px"
    // display="flex"
        
        className="relative flex flex-col  pt-[30px] pb-[50px] w-full h-[80vh] "
    
    // backgroundColor="pink"
    // width="100%"
    
    >
      <View id={`Ia`} className="relative flex flex-col bg-[rgba(255,255,255,.3)]  w-full h-full  pl-3 pr-3 rounded-3xl overflow-scroll pb-3 ">
   

    {/* Query texfield plus button */}
      <Flex
        // backgroundColor="green"
        width="100%"
        height="auto"
        justifyContent="center"
        alignItems="center"
        direction="column"
        paddingTop="20px"
        paddingBottom="20px"
        gap="10px"
        >
     
      <TextField
        position="relative"
        // className="border-red"
        // color="success"
        // boxShadow="0px 5px 15px rgba(0, 0, 0, 0.10000000149011612)"
        // backgroundColor="blu  e"
        
        // height="500px"
       multiline
       fullWidth
       
       id="outlined-basic" 
       label="Enter Query ..." 
       variant="outlined" 
      //  color='white'
      //  color='white'
      // color="secondary"
      
      
        className=' text-[rgba(255,255,255,1)]'
        // top='-20px'
        value={query}
        onChange={(e) => {
            let { value } = e.target;
            setQuery(value);
          }}
        height="85px"
      />

        <motion.div
        initial={{
            // width : "100%",
        }}
        whileHover={{
          scale : 1.1,
        //   paddingLeft : "25px"
        }}
        whileTap={{
          scale: 0.9,
          
        }}
        
        >
{/* <a href="#Da"> */}
         <Button
         position="relative"
      height="30px"
      color="black"
      className='CollectionCard'
      variation='primary'
      isLoading={isloading}
      boxShadow="0px 5px 15px rgba(0, 0, 0, 0.10000000149011612)"
    //   onMouseEnter={() => {
    //     QueryImageAgent()    
    //   }}
    //   isDisabled={dataloaded ? false : true}
    onClick={()=> {
        setisloading(true)
        QueryImageAgent()    

    }
   
}
     
      >
        Query
         </Button>
 {/* </a> */}
         </motion.div>
    
      </Flex>
    {/* Query texfield plus button */}
       
     {/* The query box itself */}
     
    
      <View 
     className="relative overflow-x-scroll h-[100%]"
        // onClick={() => {
        //     setShowQueryBox(true)
        // }}
        
        >
 {/* <motion.div
        initial={{
            // width : "100%",
        }}
        whileHover={{
          scale : 1.01,
        //   paddingLeft : "25px"
        }}
        whileTap={{
          scale: 1,
          
        }}
        
        >
       */}
{isloading ? 
        <Grid
        container
        display="flex"
        position="relative"
        justifyContent="center"
        alignItems='center'

        width="100%"
        height="100%"
        // paddingRight="50px"
        // paddingTop="40px"
        // backgroundColor="pink"
        >
          {/* <Flex
          justifyContent="flex-start"
          alignItems="center"
          position="relative"
          paddingRight="50px"
          width="50px"
          height="40px"
          marginBottom="50px"
          // backgroundColor="brown"
          > */}
          <SkewLoader
        loading="true"
        // color='#de8865cc'
        color='white'
        size="50px"
        /> 
          {/* </Flex> */}
        </Grid>
        : 
       
          <Collection
        items={projectconversation || []}
        type="list"
        direction="column"
        position="relative"
        searchNoResultsFound=" "
        searchPlaceholder="Search query"
        isSearchable   
        isPaginated
        itemsPerPage={5}     
       
    >
      {(item, index) => (   
          <Flex
          position="relative"
          // backgroundColor="pink"
          direction="column"
          gap="10px"
          paddingTop="0px"
          key={index}
           onMouseOver={() => {
            setonHoverChat(true)
            sethoverChatId(item._id)
            // console.log('hovering over', item._id);
          }}
          >
    
     {/* Chat Drop DOwn */}
                <View  display={onHoverChat && hoverChatId === item._id ? 'flex' : 'none'} className=" absolute z-50 flex justify-end w-full mt-[8px] pr-[10px] ">
                              <Menu
                                            triggerClassName="my-menu-trigger"
                                            className="my-menu-content"
                                            // className=' bg-amber-600'
                                            menuAlign="end"
                                            width="200px"
                                            height="auto"
                                            sx={{
                                              zIndex: 9999
                                            }}
                                            display="block"
                                            gap="unset"
                                            alignItems="unset"
                                            justifyContent="unset"
                                            shrink="0"
                                            position="relative"
                                            padding="0px 0px 0px 0px"
                                            // marginTop="10px"
                                            trigger={
                                            <MenuButton
                                            className="my-menu-trigger"
                                            borderRadius='5px'
                                             >
                                                <Icon
                                              width="13.5px"
                                              height="6.66px"
                                              viewBox={{
                                                minX: 0,
                                                minY: 0,
                                                width: 13.5,
                                                height: 6.662109375,
                                              }}
                                              paths={[
                                                {
                                                  d: "M0.21913 0.220211C0.511724 -0.0729808 0.986598 -0.0734649 1.27979 0.21913L5.01935 3.95108C5.4238 4.3547 5.69564 4.62517 5.92172 4.81672C6.14109 5.00259 6.26763 5.06987 6.36421 5.10121C6.61497 5.18257 6.88503 5.18257 7.13579 5.10121C7.23237 5.06987 7.35891 5.00259 7.57828 4.81672C7.80436 4.62517 8.0762 4.3547 8.48064 3.95108L12.2202 0.21913C12.5134 -0.0734649 12.9883 -0.0729808 13.2809 0.220211C13.5735 0.513402 13.573 0.988276 13.2798 1.28087L9.54022 5.01282L9.51868 5.03432C9.14132 5.41093 8.82631 5.72531 8.54795 5.96116C8.25761 6.20717 7.95825 6.41133 7.59873 6.52798C7.04707 6.70698 6.45293 6.70698 5.90127 6.52798C5.54175 6.41133 5.24239 6.20717 4.95204 5.96116C4.67368 5.7253 4.35866 5.41091 3.98129 5.03429L3.95978 5.01282L0.220211 1.28087C-0.0729808 0.988276 -0.0734649 0.513402 0.21913 0.220211Z",
                                                  fill: "white",
                                                  fillRule: "evenodd",
                                                },
                                              ]}
                                              display="block"
                                              gap="unset"
                                              alignItems="unset"
                                              justifyContent="unset"
                                              position="absolute"
                                            >
                                              
                                                </Icon>   
                                            </MenuButton>}
                                            /// Arrow next  to user.name
                                          >
                                            
                                           
                                            <Flex
                                            height='50px'
                                            // backgroundColor="red"
                                            >
                                            
                                            <Text
                                            marginTop="15px"
                                            marginLeft="18px"
                                            color="black"
                                            
                                            > 
                                            {"Response Options"}
                                            </Text>
                            
                                            </Flex>
                            
                                            <Divider />
                                   
                            
                            {/* <MenuItem
                              width='100%'
                              height='50px'
                                onClick={() => {
                                         
                                        }}
                               >
                                {'Listen'}
                              </MenuItem>
                
                
                              <MenuItem
                              width='100%'
                              height='50px'
                              className=" hover:text-white"
                              onClick={()=>{
                                // navAbout()
                              }}
                              
                               >
                                <Text
                                // fontWeight="normal"     
                                display="flex"
                                // justifyContent="center"
                                alignItems="center"
                                className=" hover:text-white"
                                width="100%"
                                height="100%"
                                // backgroundColor="red"
                                
                                >
                               {`Move`}
                                </Text>
                              </MenuItem>
                            
                             
                              <MenuItem
                              width='100%'
                              height='50px'
                              className=" hover:text-white"
                              onClick={()=>{
                                // subscribenow()
                              }}
                              
                               >
                                <Text
                                // fontWeight="normal"
                                display="flex"
                                // justifyContent="center"
                                alignItems="center"
                                className=" hover:text-white"
                                width="100%"
                                height="100%"
                                // backgroundColor="red"
                                
                                >
                                  {`Copy`}
                                </Text>
                              </MenuItem>
                           */}
                            
                              <MenuItem
                              width='100%'
                              height='50px'
                                onClick={() => {
                                          setchatIdToDelete(item._id)
                                          setdeleteChatModel(true);
                                        }}
                               >
                                {'Delete'}
                              </MenuItem>
                
                              
                                      
                              </Menu>
                </View>
              {/* Chat Drop DOwn */}  

{/* Query */}
          <Flex
          position="relative"
          width="100%"
          // backgroundColor="rgba(222,136,101,.8)"
          backgroundColor="grey"
          boxShadow="0px 5px 15px rgba(0, 0, 0, .4)"
          padding="10px 10px 10px 10px"
          borderRadius="16px"
          direction="column"
          className=' flex-wrap break-words whitespace-break-spaces text-ellipsis '
          gap="5px"
          paddingBottom="15px"
          
          >
          <Text
          // fontSize="15px"
          // backgroundColor="pink"
          color="white"
          >
          Query: 
          </Text>

          <ReactMarkdown
          className={"text-white mr-5 ml-5"}
          >
            
          
          {item.query}
          
          
        
         
          </ReactMarkdown>
          {/* <GetImageUrl img={item.image}/> */}

          </Flex>
{/* Query */}
          
{/* Response */}
          <Flex
          position="relative"
          width="100%"
          backgroundColor="rgba(255,255,255,.6)"
          boxShadow="0px 5px 15px rgba(0, 0, 0, 0.4)"
          padding="10px 10px 10px 10px"
          borderRadius="16px"
          direction="column"
          gap="5px"
           paddingBottom="15px"                             
          >
            <Text
            color="black"
          // backgroundColor="pink"
          >
          Response: 
          </Text>


          <ReactMarkdown
          className={"text-black mr-5 ml-5"}
          >
            
          
          {item.response}
          
          
          
        
         
          </ReactMarkdown>
                                  
          <DisplayImage image_key={item.image_url} />

            {/* <Image
             src={item.image_url} 
             position="relative"
         objectFit="cover"
        //  backgroundColor="red"
         width="100%"
         height="100%"
         onClick={() => {
            setcurrentkey(item.image_url)
            setshowdata(true)
         }}

             
             /> */}
          
          </Flex>
{/* Response */}
          </Flex>
      )}
          </Collection>
         
          }
        
 {/* </motion.div> */}
      </View>
     
    </View>
    {/* The query box itself */}
    
    <Modal
                 isOpen={deleteChatModel}
                 onRequestClose={closeDeleteChatModal}
                 style={{
                     overlay: {
                     position: 'fixed',
                     display: 'flex',
                     justifyContent: 'center',
                     alignItems: 'center',
                     top: 0,
                     left: 0,
                     right: 0,
                     bottom: 0,
                     backgroundColor: 'rgba(255, 255, 255, 0.75)',
                     zIndex: 999,
                     },
                     content: {
                     position: 'relative',
             //   display
                     top: '0px',
                     left: '0px',
                     right: '0px',
                     bottom: '0px',
                     border: '0px solid #ccc',
                     
               background: "gray",
             //   width: "302px",
             //   overflow: 'auto',
                     WebkitOverflowScrolling: 'touch',
                     borderRadius: '20px',
                     outline: 'none',
                     padding: '0px'
                     }
                 }}
                 >
        
        <Flex
                   position="relative"
                   justifyContent="center"
                   alignItems="center"
                   direction="column"
                   textAlign="center"
                   width="300px"
                   height="200px"
                  
                   >
                
                 <Text
                 position="relative"
                 color="white"
                 fontSize="20px"
                 fontWeight="extrabold"
                 
                 >
                   
                     Are you sure you want to delete this Chat?
                  
                     
                     
        
                 </Text>
                 <Flex
                 width="100%"
                 // backgroundColor="pink"
                 position="relative"
                 wrap="nowrap"
                 gap="50px"
                 height="auto"
                 justifyContent="center"
                 paddingTop="5px"
                 >
                    <motion.button
             whileHover={{scale : 1.2}}
             whileTap={{scale: 0.9}}
             onClick={ async () => {
        
           
           
             setisloading(true);   
             closeDeleteChatModal();
             const response = await deleteProjectChat(chatIdToDelete);
             if(response){
              setnewquery(true);
             } else {
              setisloading(false)
             }
             
             
        
            //  window.scrollTo(0,0)
          
            }}
             
             >
                   <Text
                   
                   color="white"
                   backgroundColor="rgba(255,255,255,.5)"  
                   display="flex"           
                   height="35px"
                   width="45px"
                   justifyContent="center"
                   alignItems="center"
                  //  textAlign="center"
                   borderRadius="5px"
                   fontWeight="bold"
                   className='relative cursor-pointer'
                   
                   >
                     Yes
                   </Text>
                   </motion.button>
                   <motion.button
             whileHover={{scale : 1.2}}
             whileTap={{scale: 0.9}}
             onClick={closeDeleteChatModal}
             >
                   <Text
                   color="white"
                   backgroundColor="rgba(255,255,255,.5)"
                   display="flex"           
                   height="35px"
                   width="45px"
                   justifyContent="center"
                   alignItems="center"
                  //  textAlign="center"
                   borderRadius="5px"
                   fontWeight="bold"
                   className='cursor-pointer'
                   >
                     No
                   </Text>
                   </motion.button>
                 </Flex>
                 
                 
                   </Flex>
                   
                 
        </Modal>  
       <Modal
    isOpen={showQueryBox}
    onRequestClose={closeQueryBox}
    style={{
        overlay: {
          position: 'fixed',
          display: 'flex',
          justifyContent: 'flex-start',
        //   alignItems: 'center',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255,255,255,.8)',
          zIndex: 999,
          paddingLeft: "20px",
          overflow: "scroll",
          paddingTop: "20px",
          paddingBottom: "10px",
          paddingRight: "20px"
        },
        content: {
          position: 'relative',
          display: "block",
          top: '0px',
          left: '0px',
          right: '0px',
          bottom: '0px',
          border: '3px solid grey',
          boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.10000000149011612)",
        //   minHeight: "auto",
          minHeight: "auto",

        maxHeight: "95vh",
          background: 'grey',
          width: "100%",
          overflow: "hidden",
          WebkitOverflowScrolling: 'touch',
          borderRadius: '15px',
          outline: 'none',
          paddingTop: "0px",
          paddingBottom: "20px",
          paddingLeft: "20px",
          paddingRight: "20px"


        }
      }}
    
    >
        
        {/* <Text
        width="100%"
        textAlign="center"
        backgroundColor="red"
        >
            Image Agent
        </Text> */}
   


       <ModalImageAgent 
       projectname={currentproject}
       closeQueryBox={closeQueryBox}
       />

       </Modal>

      
   
     </View>
  )
}